import React, {Fragment} from "react";
import Select from "../ui-components/Select";
import Input from "ui-components/Input";
import Toggle from "../ui-components/Toggle";
import ServiceConfiguratorBlockInputOption from "./ServiceConfiguratorBlockInputOption";
import ServiceConfiguratorBlockInputKColor from "./ServiceConfiguratorBlockInputKColor";
import {useState} from "react";
import {CONNETTORI_INPUT_TYPES} from "@feature/services/connettori";

const inputTypes = [
  {
    name: "True - False",
    value: "bool",
  },
  {
    name: "Select",
    value: "select",
    hasCustomInput: true,
    hasOption: true,
  },
  {
    name: "Multi select",
    value: "multi_select",
    hasOption: true,
  },
  {
    name: "Text input",
    value: "text_input",
  },
  {
    name: "Number input",
    value: "number_input",
    hasCustomInput: true,
  },
  {
    name: "KCC color",
    value: "kcc_color_input",
  },
  {
    name: "K-Color",
    value: "k_color_input",
  },
  {
    name: "Connettori",
    value: "connector_input",
  },
  {
    name: "Rinforzo nodo",
    value: "node_reinforcement_input",
  }
];

const ServiceConfiguratorBlockInput = ({ newData, setNewData, editable, ...rest }) => {

  const {
    // for KColor input modularization
    newCrossData,
    setNewCrossData,
    //-------------------------
    setShowDependencies,
    block,
    questions,
    recursiveQuestions,
    outputs,
    data,
    type,
    service,
  } = rest;

  // state
  const [associated, setAssociated] = useState(!!newData.id_source_configuration);

  // utilities
  const inputType = newData?.input_type
    ? inputTypes.find((i) => i.value === newData.input_type)
    : null;

  const renderOutputOption = ({data: {label, title}, innerProps, innerRef}) => (
    <article
      ref={innerRef} {...innerProps}
      className="text-sm py-2 px-3 cursor-pointer hover:bg-blue-50 flex flex-col gap-0.5"
    >
      <p className="font-medium">{label}</p>
      <p className="text-gray-500 text-xs">{title}</p>
    </article>
  );

  return (
    <div className="w-full flex flex-col mb-4">
      <p className="font-bold mb-4">Question options</p>
      <Select
        disabled={!editable}
        label="Question type"
        options={[{ value: "", name: "" }, ...inputTypes]}
        value={newData.input_type || ""}
        onChange={(e) => {
          const t = e.target.value;
          setNewData((prev) => ({
            ...prev,
            input_type: t,
            id_source_configuration: null, // reset associations
            metadata_:
              prev.input_type !== "connector_input" && t === "connector_input"
                ? { type: "geometria" }
                : null,
          }));
        }}
      />

      {inputType?.hasCustomInput ? (
        <Fragment>
          <div className="mt-2">
            <Input
              disabled={!editable}
              value={newData.metadata_?.uom_question || ""}
              label="Unit of Measurement"
              onChange={(e) => {
                setNewData((prev) => ({
                  ...prev,
                  metadata_: {
                    ...(prev.metadata_ || {}),
                    uom_question: e.target.value,
                  },
                }));
              }}
              type="text"
            />
            <Input
              disabled={!editable}
              value={newData.metadata_?.symbol_question || ""}
              label="Symbol"
              onChange={(e) => {
                setNewData((prev) => ({
                  ...prev,
                  metadata_: {
                    ...(prev.metadata_ || {}),
                    symbol_question: e.target.value,
                  },
                }));
              }}
              type="text"
            />
          </div>
        </Fragment>
      ) : null}

      {inputType?.value === "connector_input" && (
        <Select
          disabled={!editable}
          label="Block type"
          options={CONNETTORI_INPUT_TYPES.map((t) => ({
            name: _.capitalize(t),
            value: t,
          }))}
          value={newData.metadata_?.type || ""}
          onChange={(e) => {
            setNewData((prev) => ({
              ...prev,
              metadata_: {
                ...(prev.metadata_ || {}),
                type: e.target.value,
              },
            }));
          }}
        />
      )}
      {inputType?.value === "k_color_input" && (
        <ServiceConfiguratorBlockInputKColor
          newData={newCrossData ? newCrossData : newData}
          setNewData={newCrossData ? setNewCrossData : setNewData}
          setShowDependencies={setShowDependencies}
          editable={editable}
          block={block}
          questions={questions}
          recursiveQuestions={recursiveQuestions}
          outputs={outputs}
          data={data}
          type={type}
          service={service}
          {...rest}
        />
      )}

      {inputType?.hasOption ? (
        <Fragment>
          <Toggle
            disabled={!editable}
            label="Question with button"
            checked={newData.button_select_question}
            onChange={() =>
              setNewData({
                ...newData,
                button_select_question: !newData.button_select_question,
              })
            }
          />
          <ServiceConfiguratorBlockInputOption inputId={newData.id} {...rest} editable={editable} />
        </Fragment>
      ) : null}
    </div>
  );
};

export default ServiceConfiguratorBlockInput;
